<template>
  <div class="login">
    <div class="modal login-modal">
      <LoginSMSModal :verify="true" />
      <LoginLineModal v-if="isLineLogin" :key="lineKey" />
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <h1 class="title has-text-link is-4">{{ msg }}</h1>
          <div>
            <a class="button is-warning is-medium is-fullwidth" @click="openSMSLoginModal">
              <i class="fa fa-sms fa-lg"></i>
              &nbsp;{{ $t("login.login") }}
            </a>
          </div>
          <div v-if="notIOSApp">
            <!-- <div v-if="false"> -->
            <br />
            <div>
              <fb-signin-button :params="fbParams" @success="fbSuccess" @error="fbError">
                <a class="button is-link is-medium is-fullwidth" @click="fbLoading">
                  <i class="fab fa-facebook fa-lg"></i>
                  &nbsp;{{ $t("login.login") }}
                </a>
              </fb-signin-button>
            </div>
            <br />
            <div>
              <a class="button is-success is-medium is-fullwidth" @click="openLineLoginModal">
                <i class="fab fa-line fa-lg"></i>
                &nbsp;{{ $t("login.login") }}
              </a>
            </div>
          </div>

          <!-- style="height:50px" -->
          <!-- </div> -->
          <!-- <div v-show="showLoginOption('line')">
            <a class="button is-success is-fullwidth" href="http://nav.cx/5n0PM2V">
              <i class="fab fa-line fa-2x"></i>&nbsp;Login
            </a>
            <br />
          </div>-->
        </section>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import LoginSMSModal from "@/components/LoginSMSModal.vue";
import LoginLineModal from "@/components/LoginLineModal.vue";

export default {
  name: "Login",
  components: {
    LoginSMSModal,
    LoginLineModal,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      isLineLogin: false,
      lineKey: 0,
      fbParams: {},
      loader: null,
    };
  },
  computed: {
    loginState() {
      return this.$store.getters.isLoggedIn;
    },
    notIOSApp() {
      return true; // turned on again 7 Dec 2023 to allow non-Thai numbers to login
      // return !this.isIOSApp(); // used to hide FB login on iOS app
    },
  },
  watch: {
    loginState(state) {
      // logged in state t/f
      if (state) {
        if (!this.$store.state.user.language) {
          // set current language to user if empty on their profile
          // if current language is not empty as well
          this.$store.dispatch("setLanguage", this.$store.state.language);
        } else {
          this.setLang(this.$store.state.user.language, true);
        }
        this.closeModal();
        return;
      }
      // else user just logged out so ask them to log back in
      // EventBus.$emit("OPEN_LOGIN_MODAL", this.$t("login.please-login")); // else if logged out open modal
      if (this.$route.name !== "no-such-user") {
        EventBus.$emit("OPEN_LOGIN_SMS_MODAL");
      }
    },
  },
  mounted() {
    EventBus.$on("CLOSE_LINE_LOGIN", () => (this.isLineLogin = false));
  },
  methods: {
    fbLoading() {
      this.loader = this.loadingDots();
    },
    fbError(err) {
      this.console("facebook login api error", err);
      this.loader.hide();
    },
    fbSuccess(res) {
      this.console("fbSuccess", res);
      FB.api(
        "/me",
        { fields: "id,name,email,picture.width(500).height(500)" },
        (fbUser) => {
          // var loader = this.loadingDots();
          this.console(`Good to see you, ${fbUser.name}.`, fbUser);
          this.$store
            .dispatch("getUser", {
              source: "facebook",
              id: fbUser.id,
            })
            .then((res) => {
              this.console("get facebook user response", res);
              if (res.data === "new facebook user") {
                this.createNewFacebookUser(fbUser);
                return;
              }
              this.loginSuccessAlert();
            })
            .catch((err) => this.apiError(err))
            .finally(this.loader.hide());
        }
      );
    },
    createNewFacebookUser(fbUser) {
      var loader = this.loadingDots();
      this.$store
        .dispatch("newUser", {
          source: "facebook",
          source_user_id: fbUser.id,
          source_user_name: fbUser.name,
          profile_pic_url: fbUser.picture.data.url,
        })
        .then((res) => {
          this.console("newUserSource success", res);
          // this.loginSuccessAlert(); // use, but can I use promise with this?
          this.$swal({
            title: this.$t("login.success-title"),
            html: this.$t("login.success-text1") + " 🙏🏽",
            showConfirmButton: false,
            timer: 1500,
          })
            .then(() => {
              if (!this.$store.getters.getUserMobile) this.setMobileNumber();
            })
            .finally(() => loader.hide());
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    // showLoginOption(method) {
    // show all login options for now, previously limited based on your last login method
    // return true;
    // // return true for all if super user
    // if (this.$store.state.superUser) return true;
    // // return true for all if loginMethod is blank
    // if (this.$store.state.loginMethod === "") return true;
    // // else only return true for specific method
    // if (this.$store.state.loginMethod === method) return true;
    // // otherwise false
    // return false;
    // },
    openSMSLoginModal() {
      // EventBus.$emit("OPEN_SMS_LOGIN");
      this.displayModal(".login-sms-modal");
    },
    openLineLoginModal() {
      this.isLineLogin = true;
      this.lineKey += 1;
      this.$nextTick(() => this.displayModal(".login-line-modal"));
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  width: 95vw;
  max-width: 500px;
  margin: 0 auto;
  overflow: hidden;
  /*  hack for apple sign in !DOCTYPE issue */
  padding: 12px;
  /* border-radius: 25px; */
}

.apple {
  display: none;
}
</style>